import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard from "./ChartCard";
import ChartTooltip from "./ChartTooltip";
import { axisProps, chart, formatMinutes } from "./theme";

function CallLengthChart({ durations, averageSeconds, style }) {
  const total = durations.reduce((sum, d) => sum + d.count, 0);

  return (
    <ChartCard
      title="Call length"
      subtitle={
        averageSeconds
          ? `How long calls last. Average ${formatMinutes(averageSeconds / 60)}`
          : "How long calls last"
      }
      height={260}
      style={style}
      table={{
        columns: ["Length", "Calls"],
        rows: durations.map((d) => [d.bucket, d.count]),
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={durations}
          margin={{ top: 4, right: 8, bottom: 0, left: -12 }}
          barCategoryGap={3}
        >
          <CartesianGrid vertical={false} stroke={chart.grid} />
          <XAxis dataKey="bucket" interval={0} {...axisProps} />
          <YAxis allowDecimals={false} {...axisProps} axisLine={false} />
          <Tooltip
            cursor={{ fill: chart.cursor }}
            content={
              <ChartTooltip
                rows={(payload) => [
                  { label: "Calls", value: payload[0].value, color: "#7d72e3" },
                  {
                    label: "Share",
                    value: `${total ? Math.round((payload[0].value / total) * 100) : 0}%`,
                  },
                ]}
              />
            }
          />
          <Bar dataKey="count" fill="#7d72e3" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}

export default CallLengthChart;
